import * as Sentry from "@sentry/browser";
import React, { useEffect } from "react";
import { useAlert } from "react-alert";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";

import Navigation from "../Navigation";
import { makeRequest } from "../util";
import { FunctionsListView } from "./FunctionsListView";
import { NewFunctionBuilder } from "./NewFunctionBuilder";
import { FunctionDefView } from "./FunctionDefView";
import { SET_FUNCTIONS } from "../reducers/functions";
import { FunctionDefinition } from "./types";
import { fetchFunctionDefinitions } from "../actions/functions";

const FunctionsPage: React.FC = () => {
  const dispatch = useDispatch();
  const alert = useAlert();
  const history = useHistory();
  const { functionDefId: selectedFunctionId } = useParams<{
    functionDefId: string;
  }>();
  const { functionDefs, isLoaded } = useSelector(
    (state) => (state as any).functionDefs
  );

  const fetchFunctions = async () => {
    try {
      return await makeRequest<FunctionDefinition[]>("get_functions", {});
    } catch (error) {
      alert.error("Something went wrong. Unable to load page.");
      console.log(error);
      Sentry.captureException(error);
    }
  };

  const initializeFunctions = async () => {
    const response = await fetchFunctions();
    if (response) {
      dispatch({
        type: SET_FUNCTIONS,
        payload: response.data,
      });
    }
  };

  useEffect(() => {
    (dispatch(fetchFunctionDefinitions()) as any).catch((error: any) => {
      alert.error("Something went wrong. Unable to load page.");
      console.log(error);
      Sentry.captureException(error);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectFunction = (functionId: string) => {
    history.push(`/functions/${functionId}`);
  };

  if (!isLoaded) {
    return null;
  } else if (selectedFunctionId === "new") {
    return <NewFunctionBuilder />;
  } else if (selectedFunctionId) {
    const selectedFunctionDef = functionDefs.find(
      (functionDef: FunctionDefinition) => functionDef.id === selectedFunctionId
    );
    if (selectedFunctionDef) {
      return <FunctionDefView selectedFunctionDef={selectedFunctionDef} />;
    } else {
      return (
        <FunctionsListView
          onNewFunction={() => {
            history.push("/functions/new");
          }}
          onSelectFunction={handleSelectFunction}
          functionDefs={functionDefs}
        />
      );
    }
  } else {
    return (
      <FunctionsListView
        onNewFunction={() => {
          history.push("/functions/new");
        }}
        onSelectFunction={handleSelectFunction}
        functionDefs={functionDefs}
      />
    );
  }
};

export const FunctionsPageWithNavigation = () => {
  return (
    <Navigation className="pt-6 h-full flex flex-col">
      <FunctionsPage />
    </Navigation>
  );
};
